<template>
  <v-container fluid class="help-center pa-4 pa-md-6">
    <div class="help-center-head mb-5">
      <h1 class="help-center-title">Centre d'aide</h1>
      <p class="help-center-sub">Trouvez en quelques mots comment utiliser chaque page du tableau de bord.</p>
    </div>

    <v-text-field
      v-model="query"
      prepend-inner-icon="mdi-magnify"
      label="Rechercher dans l'aide…"
      outlined dense clearable hide-details
      class="help-search mb-6"
    />

    <div v-for="g in visibleGroups" :key="g.key" class="mb-6">
      <h2 class="help-group-label">{{ g.label }}</h2>
      <v-expansion-panels accordion focusable class="help-panels">
        <v-expansion-panel v-for="item in g.items" :key="item.name">
          <v-expansion-panel-header>
            <div class="d-flex align-center">
              <v-icon class="mr-3" color="primary">{{ 'mdi-' + item.icon }}</v-icon>
              <div>
                <div class="help-item-title">{{ item.title }}</div>
                <div class="help-item-summary">{{ item.summary }}</div>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div v-if="item.steps && item.steps.length" class="mb-3">
              <div class="help-block-label">Comment faire</div>
              <ol class="help-steps">
                <li v-for="(s, i) in item.steps" :key="i" class="mb-2">
                  <strong>{{ s.title }}.</strong> {{ s.body }}
                </li>
              </ol>
            </div>
            <div v-if="item.faqs && item.faqs.length">
              <div class="help-block-label">Questions fréquentes</div>
              <div v-for="(f, i) in item.faqs" :key="i" class="mb-2">
                <div class="help-faq-q">{{ f.q }}</div>
                <div class="help-faq-a">{{ f.a }}</div>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <div v-if="!visibleGroups.length" class="help-empty">
      Aucun résultat pour « {{ query }} ».
    </div>
  </v-container>
</template>

<script>
import { HELP, HELP_GROUPS } from '@/help/helpContent'

export default {
  name: 'HelpCenterView',
  data() {
    return { query: '' }
  },
  computed: {
    allItems() {
      return Object.keys(HELP).map((name) => Object.assign({ name }, HELP[name]))
    },
    filteredItems() {
      const q = (this.query || '').trim().toLowerCase()
      if (!q) return this.allItems
      const hit = (s) => (s || '').toLowerCase().indexOf(q) !== -1
      return this.allItems.filter((it) =>
        hit(it.title) || hit(it.summary) ||
        (it.steps || []).some((s) => hit(s.title) || hit(s.body)) ||
        (it.faqs || []).some((f) => hit(f.q) || hit(f.a)),
      )
    },
    visibleGroups() {
      return HELP_GROUPS
        .map((g) => ({ key: g.key, label: g.label, items: this.filteredItems.filter((it) => it.group === g.key) }))
        .filter((g) => g.items.length)
    },
  },
}
</script>

<style scoped>
.help-center { max-width: 980px; margin: 0 auto; }
.help-center-title { font-size: 26px; font-weight: 800; color: #2b2f52; }
.help-center-sub { color: #6b7192; margin-top: 2px; }
.help-search { max-width: 560px; }
.help-group-label { font-size: 13px; letter-spacing: .06em; text-transform: uppercase; color: #9aa0b8; font-weight: 700; margin-bottom: 10px; }
.help-item-title { font-weight: 700; color: #2b2f52; }
.help-item-summary { font-size: 13px; color: #6b7192; }
.help-block-label { font-size: 12px; letter-spacing: .06em; text-transform: uppercase; color: #9aa0b8; font-weight: 700; margin: 6px 0 8px; }
.help-steps { padding-left: 18px; color: #4a5070; }
.help-faq-q { font-weight: 600; color: #2b2f52; }
.help-faq-a { color: #6b7192; font-size: 13.5px; }
.help-empty { color: #6b7192; text-align: center; padding: 40px 0; }
</style>
